// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageTemplateBreakpoint, cartPageTemplateStyles } from "@ces/App/Components/Cart/CartPageTemplate";
import { DivWrapper } from "@ces/XDL/constants";
import { xScreen } from "@ces/XDL/Utilities";
import { LoadingSpinnerStyle } from "@insite/mobius/LoadingSpinner";
import { css } from "styled-components";

cartPageTemplateStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 995px) minmax(0, 317px);
        grid-column-gap: 22px;
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-template-columns: 1fr 1fr;
        }
        @media print {
            display: block;
        }
    `,
};

cartPageTemplateStyles.headerSection = {
    css: css`
        grid-row: 1/2;
        ${xScreen("lt", 768)} {
            grid-column: 1/3;
        }
        @media print {
            width: 100%;
        }
        ${LoadingSpinnerStyle} {
            height: 24px;
        }
    `,
};

cartPageTemplateStyles.titleSection = {
    css: css`
        width: 100%;
    `,
};

cartPageTemplateStyles.cartApproverMessage = {
    css: css`
        margin-bottom: 20px;
        &:has(${DivWrapper}:empty) {
            display: none;
        }
    `,
};

cartPageTemplateStyles.actionsSection = {
    css: css`
        width: 100%;
        margin-bottom: 12px;
        ${LoadingSpinnerStyle} {
            display: none;
        }
    `,
};

cartPageTemplateStyles.mainSection = {
    css: css`
        grid-row: 2/3;
        ${xScreen("lt", 768)} {
            grid-row: 3/3;
            grid-column: 1/3;
            width: 100%;
            padding: 0;
            margin-top: 0;
            margin-bottom: 0;
        }
        @media print {
            width: 100%;
        }
    `,
};

cartPageTemplateStyles.totalSection = {
    css: css`
        grid-row: 1/4;
        ${xScreen("lt", 768)} {
            grid-row: 2/3;
            grid-column: 1/3;
            width: 100%;
            display: flex;
            justify-content: center;
        }
    `,
};

cartPageTemplateStyles.cartFulfullmentSelector = {
    css: css`
        margin-bottom: 24px;
        &:has(${DivWrapper}:empty) {
            display: none;
        }
    `,
};

cartPageTemplateStyles.xngStickyStyles = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 24px;
        ${xScreen("lt", 768)} {
            width: 317px;
            margin-bottom: 24px;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
        @media print {
            position: static;
            > ${DivWrapper} {
                margin-bottom: 24px;
            }
        }
        > div > div > ${LoadingSpinnerStyle} {
            height: 124px;
        }
    `,
};
